<!--
================================================
Vue affichant l'interface de task tracking
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <app-layout-comp>
        <div slot="AppContent" id="TimeTrackingView" v-bind:class="{'darkMode':themeToDisplay=='dark'}">


            <task-tracking-tour-comp></task-tracking-tour-comp>


            <div class="compLoader" v-if="!componentIsReady">
                <spinner-loader-comp v-bind:loading-txt="$t('chargement')"></spinner-loader-comp>
            </div>

            <div v-else class="components">
                <current-task-comp v-if="hasCurrentTask"></current-task-comp>
                <new-task-comp v-else></new-task-comp>
            </div>


            <hr class="sep">



          <task-timerecord-list-comp></task-timerecord-list-comp>

          <getting-started-comp v-if="$auth.hasRole('ROLE_OWNER') " v-bind:user-type="'firstUser'"></getting-started-comp>
          <getting-started-comp v-else v-bind:user-type="'collaborator'"></getting-started-comp>

          <modal-project-management-comp></modal-project-management-comp>
          <modal-tag-management-comp></modal-tag-management-comp>


        </div>
    </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import AppLayoutComp from '@/components/AppLayoutComp.vue'
    // import Component from '@/components/Component.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";

    import NewTaskComp from '@/components/NewTaskComp.vue'
    import CurrentTaskComp from '@/components/CurrentTaskComp.vue'
    import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
    import TaskTimerecordListComp from '@/components/TaskTimerecordListComp.vue';
    import TaskTrackingTourComp from "@/components/TaskTrackingTourComp.vue";
    import ModalProjectManagementComp from "@/components/ModalProjectManagementComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import {mapState} from 'vuex'
    import GettingStartedComp from "@/components/GettingStarted/GettingStartedComp";
    import ModalTagManagementComp from "@/components/Tags/ModalTagManagementComp";


    export default {
        name: 'TimeTrackingView',
        components: {
          ModalTagManagementComp,
          GettingStartedComp,
            AppLayoutComp, NewTaskComp,CurrentTaskComp,SpinnerLoaderComp,TaskTimerecordListComp,
            TaskTrackingTourComp,ModalProjectManagementComp

            // Component,
        },
        mixins: [VueMetaMixin,InterceptorMixin,SentryMixin,GlobalErrorNotification],

        data: function()  {
            return{

            hasCurrentTask : false, // un boolean indiquant si un TaskTimerecord est en cours (timeOut = null)
             componentIsReady : false, // indique quant on peut afficher le composant
            }

        },
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleTimeTrackingView"),this.$t("metaDescDefault"))
        },
        //==========================================================


        computed: {
            // computed props for store :
            ...mapState({
                user: state => state.user,
                currentTaskTr: state => state.TimeTrackingView.currentTaskTimerecord,
                themeToDisplay: state => state.app.themeToDisplay

            }),

        },

        watch: {
            // quand currentTaskTimerecord est modifié dans le store on maj hasCurrentTask
            currentTaskTr: function () {
                if(this.currentTaskTr != null){
                    this.hasCurrentTask = true
                }
                else{
                    this.hasCurrentTask = false
                }
            }
        },
        methods: {

            /**
             * Récupère le dernier TaskTimeRecord
             * Permet de savoir si l'utilisateur possède actuellement une tâche en cours, de éventuellement mettre à jour le current TaskTimeRecord dans le store et d'indiquer que le composant est prêt.
             **/
            getLastTaskTimeRecord(){

                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.$auth.getUserSlug()}/timeRecords`,
                    {  params: {limit : 1, sort :'desc', type:'taskOnly', workspace : self.$auth.getActiveWorkspace()}, // on ne récupère que le dernier tr de type isTask
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                      if(response.data[0] != undefined){ // si le dernier TimeRecord existe

                            if (response.data[0].timeOut == null) {
                                // l'utilisateur possède un tâche en cours...
                                self.$store.commit('UpdateTimeTrackingViewCurrentTask', response.data[0]);
                                self.hasCurrentTask = true
                            } else {
                                self.hasCurrentTask = false

                            }

                        }
                        self.componentIsReady = true;
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')

                            let errorCode = "0011b"
                            self.showGlobalErrorNotif(self, errorCode)
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error fetching last timerecord"})
                          self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching fetching last timerecord', 'fatal': false})
                          self.$sentry.captureMessage(`Error ${errorCode} > error fetching last timerecord in PointeuseComp : ${error}`, 'error')

                        }
                    })

            },

        },
        mounted: function () {
            this.getLastTaskTimeRecord();
        },

    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
    /*@import "../assets/css/globalVar.scss";*/

    #TimeTrackingView{

      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////

      hr.sep{height: 1px; margin-top: 4rem; background: #ddd}

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
        hr.sep{background: #666}

      }
    }

    .loadingMsg{color:#999}
</style>
